package com.bikompanion.ui.settings

enum class NotificationStatus {
    Allowed,
    Off,

    /** Refused in a way the app cannot ask about again, such as a browser's site permission. */
    Blocked,
}
